/* "You've struck gold" claim form (sections/atelier-ifoundit.liquid): checks the required fields before the contact
   form posts, and when "Also make me an Argan VIP" is ticked, first posts Shopify's newsletter form (tagged vip) in
   the background so the customer joins the list too. The claim itself always goes to customer care. */
(function () {
  function init(form) {
    var vip = form.querySelector('[data-at-ifi-vip]');
    var sending = false;
    form.addEventListener('submit', function (e) {
      if (sending) return;
      var bad = null;
      form.querySelectorAll('input[required]').forEach(function (input) {
        var ok = input.value.trim() !== '' && input.checkValidity();
        input.toggleAttribute('aria-invalid', !ok);
        if (!ok && !bad) bad = input;
      });
      if (bad) { e.preventDefault(); bad.focus(); return; }
      if (!vip || !vip.checked) return;
      e.preventDefault();
      sending = true;
      var email = form.querySelector('input[name="contact[email]"]').value.trim();
      var name = (form.querySelector('input[name="contact[Name]"]') || {}).value || '';
      var data = new FormData();
      data.append('form_type', 'customer');
      data.append('utf8', '✓');
      data.append('contact[email]', email);
      data.append('contact[tags]', 'vip,newsletter,ifoundit');
      data.append('contact[accepts_marketing]', 'true');
      if (name.trim()) data.append('contact[first_name]', name.trim().split(/\s+/)[0]);
      var fired = false;
      var done = function () { if (fired) return; fired = true; form.submit(); };
      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'contact' : '/contact', { method: 'POST', body: data, credentials: 'same-origin' })
        .then(done, done);
      setTimeout(done, 4000);
    });
  }
  function boot() {
    document.querySelectorAll('.at-ifi__form').forEach(init);
    var thanks = document.querySelector('.at-ifi__thanks');
    if (thanks) thanks.focus();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
